'use client';

import { Building2 } from 'lucide-react';

interface VendorBadgeProps {
  vendorName: string;
  iconUrl?: string | null;
  size?: 'sm' | 'md' | 'lg';
}

export default function VendorBadge({
  vendorName,
  iconUrl,
  size = 'md',
}: VendorBadgeProps) {
  const sizeClasses = {
    sm: 'text-xs gap-1.5',
    md: 'text-sm gap-2',
    lg: 'text-base gap-2.5',
  };

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  return (
    <div
      className={`inline-flex items-center ${sizeClasses[size]} text-gray-600`}
    >
      {iconUrl ? (
        <img
          src={iconUrl}
          alt={`${vendorName} logo`}
          className={`${iconSizes[size]} rounded object-contain`}
        />
      ) : (
        <Building2 className={`${iconSizes[size]} text-gray-400`} />
      )}
      <span>{vendorName}</span>
    </div>
  );
}
